export enum EIntegriteType {
    Oui,
    NonFiltreDechire,
    NonPoussieresNonHomogenes,
    NonPresenceDeFixateur,
    NonPoussieresNonAdherentes,
    NonTracesHumidite,
}